import React from 'react';
import $ from 'jquery';
import Label from '../utils/label';
import Config from '../utils/config';
import '../utils/marquee';
import {getFullUrlPath} from '../utils/common'; 

export default class News extends React.Component {
	state = {
		logined: Config.appConfig.Logined,
		isClick: Config.appConfig.Logined && Config.appConfig.ActStatus !== '1' ? 'is-click' : '',
		publMessage: '',
		privMessage: '',
		oldPublMessage: Config.appConfig.LastTopNews ? Config.appConfig.LastTopNews : '',
		oldPrivMessage: Config.appConfig.LastTopPrivateNews ? Config.appConfig.LastTopPrivateNews : '',
		privCount: 0,
		showPopMSG: false,
		popMSG: '',
		skinPath: Config.appConfig.TemplatePath,
		ActStatus: Config.appConfig.ActStatus,
		allMSG: ''
    };
    
    loadTopNews() {
        // var self = this;
        const hotnews = this.state.publMessage,
              hotprinews = this.state.privMessage,
              oldnews = this.state.oldPublMessage,
              oldprinews = this.state.oldPrivMessage;
        let count = this.state.privCount;
        if (oldnews != '' && hotnews != oldnews && hotnews.length > 0) {
            // var self = this;
            this.setState({
                showPopMSG: true,
                popMSG: hotnews,
                oldPublMessage: this.state.publMessage.replace(/\"/g, '&quot;')
            });
            //setTimeout(() => { this.setState({showPopMSG: false}); }, 30000);

            setTimeout(() => {
                this.setState({ showPopMSG: false });
            }, 30000);
        }

        if (this.state.ActStatus == '2') {
            if (hotprinews != oldprinews && hotprinews.length > 0) {
                count++;
                this.setState({
                    privCount: count,
                    oldPrivMessage: this.state.privMessage.replace(/\"/g, '&quot;')
                });
                if (hotprinews.length > 25) {
                    this.setState({
                        showPopMSG: true,
                        popMSG: hotprinews
                    });
                    //setTimeout(() => { this.setState({showPopMSG: false}); }, 30000);
                    setTimeout(() => {
                        this.setState({ showPopMSG: false });
                    }, 30000);
                }
            }
        }
    }

    popMessage(target, wx, wy) {
        const Title = Config.appConfig.SiteTitle;
        if (navigator.appVersion.indexOf('Chrome') > 0) {
            wx += 100;
        }
        let x = (screen.width - wx) / 2;
        let y = x = (screen.height - wx) / 2;
        //add start, issue #15363,for browser 360 of ie mode
        if (x < 0) {
            x = 0;
        }
        if (y < 0) {
            y = 0;
        }
        //add end
        window.open(
            'NewIndex/Popup?Type=7&Key=' + target,
            Title,
            'left=' +
                x +
                ',top=' +
                y +
                ',width=' +
                wx +
                ',height=' +
                wy +
                ',location=no,resizable=no,scrollbars=yes'
        );
    }

    getMsg(isPublic) {
        // var self = this;

        $.ajax({
            url: getFullUrlPath('getMSG.ashx'),
            cache: false,
            data: { ispublic: isPublic, sPricount: this.state.privCount },
            dataType: 'json'
        }).done((data) => {
            if (isPublic == 'true') {
                this.setState({
                    publMessage: data.Message
                }, this.setAllMsg);
            } else {
                this.setState({
                    privMessage: data.Message,
                    privCount: data.Count
                }, this.setAllMsg);
            }
            this.loadTopNews();
        });
    }

    setAllMsg() {
        let allMSG = '';
        // var self = this;
        if ((this.state.ActStatus == '2') & (this.state.privMessage != '')) {
            allMSG =
                this.state.publMessage +
                ';<font color=green>' +
                Label.lbl_privatemsg +
                ':' +
                this.state.privMessage +
                '</font>';
        } else {
            allMSG = this.state.publMessage;
        }

        if (allMSG !== this.state.allMSG) {
            this.setState({
                allMSG: allMSG
            }, () => this.updateMarquee(allMSG));
        }
    }

    updateMarquee(message) {
        $('#marquee')
            .html(message.replace(/(< ?br ?\/?>)*/g,""))
            .marquee({
                //speed in milliseconds of the marquee
                duration: 8000,
                pauseOnHover: true,
                //gap in pixels between the tickers
                gap: 1000
            });
    }

    hotnewHandler() {
        if (this.state.ActStatus == '2') {
            this.popMessage('', 860, 600);
        }
    }

    personalHandler() {
        // var self = this;
        this.setState({
            privCount: 0
        });
        this.popMessage('private', 860, 600);
    }

    closePop() {
        this.setState({
            showPopMSG: false
        });
    }

    componentWillMount() {
        this.intervals = [];

        this.getMsg('true');
        if (this.state.ActStatus == '2') {
            this.getMsg('false');
        }
    }

    setInterval() {
        this.intervals.push(setInterval.apply(null, arguments));
    }

    componentDidMount() {
        // var self = this;
        this.setInterval(() => {
            this.getMsg('true');
            if (this.state.ActStatus == '2') {
                this.getMsg('false');
            }
        }, 60000);
    }

    componentWillUnmount() {
        this.intervals.map(clearInterval);
    }

    render() {
        return (
            <div className="news-box">
                <div className="news">
                    <strong className="title">{Label.lbl_HOTNews}</strong>
                    <div
                        id="marquee"
                        onClick={() => this.hotnewHandler()}
                        style={{overflow: 'hidden'}}
                        className={"marquee " + this.state.isClick}
                    />
                </div>
                {this.state.showPopMSG && (
                    <div className="news-popup">
                        <div className="cross" onClick={() =>this.closePop()}>
                            <i className="icon-close" />
                        </div>
                        <div className="info">
                            <i className="icon-info-circle" />
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: this.state.popMSG}}></p>
                    </div>
                )}
            </div>
        );
    }


}
